export enum Footnote {
    ONLY_AVAILABLE_IN_SELECT_STATES = 'Available only for select states. See policy for additional details.'
}